import * as _ from 'underscore';

var hash = {};

function _set(obj, interval?, callback?) {
    obj.interval = typeof interval !== 'undefined' ? interval : obj.interval;

    obj.callback = typeof callback !== 'undefined' ? callback : obj.callback;

    if (obj.interval == null) {
        _unset(obj);
    } else {
        obj.id = setInterval(obj.callback, obj.interval * 1000);
    }
}

function _unset(obj) {
    if (obj.id == null) {
        return;
    }

    clearInterval(obj.id);
    delete obj.id;
}

export function register(key, interval, callback) {
    if (callback == null) {
        return;
    }

    if (hash[key] != null) {
        hash[key].count += 1;
        return update(key, interval, callback);
    }

    var obj: any = (hash[key] = {});
    obj.count = 1;

    _set(obj, interval, callback);
}

export function update(key, interval?, callback?) {
    var obj = hash[key];

    if (obj == null) {
        return register(key, interval, callback);
    }

    _unset(obj);
    _set(obj, interval, callback);
}

export function stop(key) {
    var obj = hash[key];

    if (obj == null) {
        return;
    }

    obj.count -= 1;

    if (obj.count > 0) {
        return;
    }

    _unset(obj);

    delete hash[key];
}
